module.exports = __webpack_public_path__ + "img/img5.1e30dffb.jpg";